export const ELEMENT_COLORS: { [key: string]: string } = {
  Fire: "#ff0000",
  Water: "#155ccf",
  Air: "#76ebeb",
  Earth: "#14a314",
  Ether: "#68478d",
};

export const TEMPERAMENT_COLORS: { [key: string]: string } = {
  Rakshasa: "#dc3912",
  Manushya: "#6a6e09",
  Dev: "#3f0fb7",
};

export const DOSHA_COLORS: { [key: string]: string } = {
  Vata: "#f99203",
  Pitta: "#867ef1",
  Kapha: "#32e5e6",
};

export const ORIENTATION_COLORS: { [key: string]: string } = {
  "Adho Mukha": "#dc3912",
  "Tiryanga Mukha": "#3366cc",
  "Urdhwa Mukha": "#ff9900",
};

export const GUNAS_COLORS: { [key: string]: string } = {
  Rajas: "#3366cc",
  Tamas: "#dc3912",
  Sattwa: "#ff9900",
};

export const MOTIVATION_COLORS: { [key: string]: string } = {
  Dharma: "#ffa03c",
  Artha: "#0392b2",
  Kama: "#8ba64e",
  Moksha: "#9085ab",
};

export const TRIMURTI_COLORS: { [key: string]: string } = {
  "Brahma (Create)": "#d2b146",
  "Vishnu (Maintain)": "#009dff",
  "Shiva (Dissolve)": "#fbfaf9",
};

export const getChartSlices = (
  data: any[],
  colorMapping: { [key: string]: string }
): { color: string }[] => {
  if (!data || data.length <= 1) return [];

  return data.slice(1).map((item) => {
    const key = item[0];
    return { color: colorMapping[key] || "#999999" };
  });
};
